import { render, staticRenderFns } from "./button-tabs.vue?vue&type=template&id=71100d93&scoped=true&lang=pug&"
import script from "./button-tabs.vue?vue&type=script&lang=js&"
export * from "./button-tabs.vue?vue&type=script&lang=js&"
import style0 from "./button-tabs.vue?vue&type=style&index=0&id=71100d93&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71100d93",
  null
  
)

export default component.exports